import { render, staticRenderFns } from "./InfoInvestigation.vue?vue&type=template&id=e3cf8364&scoped=true"
import script from "./InfoInvestigation.vue?vue&type=script&lang=js"
export * from "./InfoInvestigation.vue?vue&type=script&lang=js"
import style0 from "./InfoInvestigation.vue?vue&type=style&index=0&id=e3cf8364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cf8364",
  null
  
)

export default component.exports